(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-sidebar"] && !Shopify.designMode) return;
  try {
    // class SidebarCollapse extends HTMLElement {
  //   constructor() {
  //     super();
  //     this.button = this.querySelector(".blog-posts__sidebar-collapse-button");
  //     this.content = this.querySelector(".blog-posts__sidebar-collapse-content");
  //   }

  //   connectedCallback() {
  //     this.button.addEventListener("click", () => {
  //       this.content.setAttribute("aria-expanded", this.content.getAttribute("aria-expanded") === "true" ? "false" : "true");
  //     });
  //   }
  // }

  // customElements.define("sidebar-collapse", SidebarCollapse);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_cart-countdown"] && !Shopify.designMode) return;
  try {
    class cartCountdownComponent extends HTMLElement {
    constructor() {
      super();
      this.minutes = parseInt(this.getAttribute('data-minutes')) || 4;
      this.timeDisplay = this.querySelector('.time');
      this.storageKey = 'cartCountdownTime';
      this.intervalId = null;
      
      this.init();
    }

    init() {
      const storedTime = this.getStoredTime();
      const totalSeconds = storedTime !== null ? storedTime : this.minutes * 60;
      
      this.startCountdown(totalSeconds);
    }

    getStoredTime() {
      if (Shopify.designMode) return null;
      
      const stored = sessionStorage.getItem(this.storageKey);
      return stored ? parseInt(stored) : null;
    }

    setStoredTime(seconds) {
      if (!Shopify.designMode) {
        sessionStorage.setItem(this.storageKey, seconds.toString());
      }
    }

    clearStoredTime() {
      if (!Shopify.designMode) {
        sessionStorage.removeItem(this.storageKey);
      }
    }

    formatTime(totalSeconds) {
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }

    updateDisplay(totalSeconds) {
      if (this.timeDisplay) {
        this.timeDisplay.textContent = this.formatTime(totalSeconds);
      }
    }

    async clearCart() {
      try {
        const response = await fetch(`${Shopify.routes.root}cart/clear.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          }
        });
        
        if (response.ok) {
          window.location.href = `${Shopify.routes.root}cart`;
        } else {
          throw new Error('Failed to clear cart');
        }
      } catch (error) {
        console.error('Error clearing cart:', error);
        window.location.href = `${Shopify.routes.root}cart`;
      }
    }

    startCountdown(totalSeconds) {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }

      this.updateDisplay(totalSeconds);

      this.intervalId = setInterval(() => {
        totalSeconds--;
        
        this.updateDisplay(totalSeconds);
        this.setStoredTime(totalSeconds);

        if (totalSeconds <= 0) {
          this.onCountdownComplete();
        }
      }, 1000);
    }

    onCountdownComplete() {
      clearInterval(this.intervalId);
      this.clearStoredTime();
      this.updateDisplay(0);
      
      this.clearCart();
    }

    disconnectedCallback() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    }
  }

  customElements.define('cart-countdown-component', cartCountdownComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-customer-viewing"] && !Shopify.designMode) return;
  try {
    class CustomerViewingComponent extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.init();
    }

    init() {
      const numberElem = this.querySelector('[data-customer-viewing-number]');
      if (!numberElem) return;

      const numbersViewerStr = this.dataset.customerView;
      if (!numbersViewerStr) return;

      const numbersViewerList = numbersViewerStr
        .split(',')
        .map(item => parseInt(item.trim(), 10))
        .filter(num => !isNaN(num) && num > 0);

      if (!numbersViewerList.length) return;

      let timeViewer = parseInt(this.dataset.customerViewTime, 10);
      if (isNaN(timeViewer) || timeViewer < 1) timeViewer = 5;
      timeViewer = timeViewer * 1000;

      const updateNumber = () => {
        const randomIdx = Math.floor(Math.random() * numbersViewerList.length);
        const value = numbersViewerList[randomIdx];
        numberElem.textContent = value;
      };

      updateNumber();

      this.timer = setInterval(updateNumber, timeViewer);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('customer-viewing-component')) {
      customElements.define('customer-viewing-component', CustomerViewingComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-positive-vibes"] && !Shopify.designMode) return;
  try {
    class PositiveVibesComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const parent = this.querySelector('.text-vibes');
      const children = this.querySelectorAll('.text-vibes--child');
      let currentIndex = 0;

      if (children.length > 1) {
        const newDiv = document.createElement("div");
        newDiv.classList.add("text-vibes--child");
        newDiv.innerHTML = children[0].innerHTML;
        parent.appendChild(newDiv);

        const childrenTexts = parent.querySelectorAll('.text-vibes--child');
        setInterval(() => {
          if (parent) {
            parent.classList.add('js-active');
          }
          const height = childrenTexts[currentIndex].offsetHeight;
          childrenTexts.forEach((child, index) => {
            parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: all .5s ease;`;
            if (currentIndex == 0) {
              parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: none;`;
            }
          });
          currentIndex = (currentIndex + 1) % childrenTexts.length;
          this.heightPositive();
        }, 3000);
      }
    }

    heightPositive() {
      const parent = this.querySelector('.text-vibes');
      const childrenTexts = this.querySelectorAll('.text-vibes--child');

      let maxHeight = 0;
      childrenTexts.forEach(child => {
        maxHeight = Math.max(maxHeight, child.querySelector('p').offsetHeight);
      });

      this.style.minHeight = maxHeight + 'px';

      childrenTexts.forEach(child => {
        child.style.minHeight = `${maxHeight}px`;
      });
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('positive-vibes-component')) {
      customElements.define('positive-vibes-component', PositiveVibesComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-sold-in-last"] && !Shopify.designMode) return;
  try {
    class SoldInLastComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const numberElem = this.querySelector('[data-sold-out-number]');
      const hoursElem = this.querySelector('[data-sold-out-hours]');

      let numbersListStr = this.dataset.items || this.getAttribute('data-items') || "3,5,6,7,8,10,12,15";
      let hoursListStr = this.dataset.hours || this.getAttribute('data-hours') || "10,15,16,17,18,20,25,35";

      const numbersList = numbersListStr.split(',').map(item => item.trim()).filter(item => !!item);
      const hoursList = hoursListStr.split(',').map(item => item.trim()).filter(item => !!item);

      const numberIdx = Math.floor(Math.random() * numbersList.length);
      const hourIdx = Math.floor(Math.random() * hoursList.length);

      if (numberElem && numbersList.length > 0) {
        numberElem.textContent = numbersList[numberIdx];
      }
      if (hoursElem && hoursList.length > 0) {
        hoursElem.textContent = hoursList[hourIdx];
      }
      this.classList.remove('loading');
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('sold-in-last-component')) {
      customElements.define('sold-in-last-component', SoldInLastComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-tab-item"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length === 0 || tabContents.length === 0) return;

    tabContents[0].classList.add('is-active');

    tabTitles.forEach(title => {
      title.addEventListener('click', function(e) {
        e.preventDefault();
        tabContents.forEach(content => {
          content.classList.remove('is-active');
        });
        const tabContent = this.nextElementSibling;
        if (tabContent) {
          tabContent.classList.add('is-active');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    class StickyATC extends HTMLElement {
    constructor() {
      super();

    this.form = null;
    this.mainProductInfo = null;
    this.mainVariantSelects = null;
    this.stickyVariantSelects = null;
    this.isSyncing = false;
    this.cartErrorUnsubscriber = null;
    
    this.init();
  }
  
  init() {
    this.findMainForm();
    
    if (this.form) {
      const observer = new IntersectionObserver(this.onScroll.bind(this));
      observer.observe(this.form);
    } else {
      console.warn('Sticky ATC: Could not find product form');
    }
    
    setTimeout(() => {
      this.initializeVariantSync();
    }, 100);
    
    this.setupErrorSync();
  }
  
  setupErrorSync() {
    this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
      const mainErrorWrapper = this.mainProductInfo?.querySelector('.product-form__error-message-wrapper');
      const stickyErrorWrapper = this.querySelector('.product-form__error-message-wrapper');
      
      if (!mainErrorWrapper || !stickyErrorWrapper) return;
      
      const errorMessage = mainErrorWrapper.querySelector('.product-form__error-message')?.textContent;
      
      const stickyErrorMessage = stickyErrorWrapper.querySelector('.product-form__error-message');
      if (stickyErrorMessage && errorMessage) {
        stickyErrorWrapper.toggleAttribute('hidden', false);
        stickyErrorMessage.textContent = errorMessage;
      } else {
        stickyErrorWrapper.toggleAttribute('hidden', true);
      }
    });
    
    if (this.mainProductInfo) {
      const errorWrapper = this.mainProductInfo.querySelector('.product-form__error-message-wrapper');
      if (errorWrapper) {
        const observer = new MutationObserver(() => {
          const stickyErrorWrapper = this.querySelector('.product-form__error-message-wrapper');
          if (!stickyErrorWrapper) return;
          
          const isVisible = !errorWrapper.hasAttribute('hidden');
          const errorMessage = errorWrapper.querySelector('.product-form__error-message')?.textContent;
          
          stickyErrorWrapper.toggleAttribute('hidden', !isVisible);
          if (isVisible && errorMessage) {
            const stickyErrorMessage = stickyErrorWrapper.querySelector('.product-form__error-message');
            if (stickyErrorMessage) {
              stickyErrorMessage.textContent = errorMessage;
            }
          }
        });
        
        observer.observe(errorWrapper, {
          attributes: true,
          attributeFilter: ['hidden'],
          childList: true,
          subtree: true
        });
      }
    }
  }
  
  disconnectedCallback() {
    if (this.cartErrorUnsubscriber) {
      this.cartErrorUnsubscriber();
    }
  }
  
  findMainForm() {
      const productInfo = document.querySelector('product-info');
      if (productInfo) {
        this.form = productInfo.querySelector('product-form-component form[data-type="add-to-cart-form"]');
      }
      
    if (!this.form && this.getAttribute('form')) {
      this.form = document.getElementById(this.getAttribute('form'));
      }

      if (!this.form) {
        this.form = document.querySelector('form[data-type="add-to-cart-form"]');
    }
  }
  
  initializeVariantSync() {
    const sectionId = this.getAttribute('data-sticky-section-id');
    this.mainProductInfo = document.querySelector(
      sectionId
        ? `product-info[data-section="${sectionId}"], product-info[data-original-section="${sectionId}"]`
        : 'product-info'
    ) || document.querySelector('product-info');

    this.stickyVariantSelects = this.querySelector('variant-selects');
    
    if (this.mainProductInfo) {
      this.mainVariantSelects = this.mainProductInfo.querySelector('variant-selects');
    }
    
    if (this.stickyVariantSelects && this.mainVariantSelects) {
      this.setupVariantSync();
      this.setupToggleButton();
      this.syncInitialState();
      this.updateStickyAvailabilityFromMain();
      this.observeMainAvailabilityChanges();
    }
  }
  
  setupVariantSync() {
    this.mainVariantSelects.addEventListener('change', (event) => {
      if (this.isSyncing) return;
      this.syncMainToSticky(event);
      this.updateStickyAvailabilityFromMain();
    });
    
    this.stickyVariantSelects.addEventListener('change', (event) => {
      if (this.isSyncing) return;

      const t = this.getInputFromEventTarget(event.target);
      if (t && t.type === 'radio') {
        const wrapper = t.closest('.product-form__input') || this.stickyVariantSelects;
        wrapper
          .querySelectorAll('input[type="radio"]')
          .forEach((el) => {
            el.classList.remove('checked');
            if (el.nextElementSibling && el.nextElementSibling.tagName === 'LABEL') {
              el.nextElementSibling.classList.remove('checked');
            }
          });
        t.classList.add('checked');
        if (t.nextElementSibling && t.nextElementSibling.tagName === 'LABEL') {
          t.nextElementSibling.classList.add('checked');
        }
      }

      this.syncStickyToMain(event);
    });

    this.stickyVariantSelects.addEventListener('click', (event) => {
      if (this.isSyncing) return;
      const input = this.getInputFromEventTarget(event.target);
      if (!input) return;

      if (input.type === 'radio') {
        const wrapper = input.closest('.product-form__input') || this.stickyVariantSelects;
        wrapper
          .querySelectorAll('input[type="radio"]')
          .forEach((el) => {
            el.classList.remove('checked');
            if (el.nextElementSibling && el.nextElementSibling.tagName === 'LABEL') {
              el.nextElementSibling.classList.remove('checked');
            }
          });
        input.classList.add('checked');
        if (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL') {
          input.nextElementSibling.classList.add('checked');
        }
      }

      requestAnimationFrame(() => {
        this.syncStickyToMain({ target: input });
      });
    });
  }
  
  setupToggleButton() {
    const buttonToggleVariants = this.querySelector('.button-toggle-variants');
    const overlay = this.querySelector('overlay-component');
    if (!buttonToggleVariants) return;

    const closePanel = () => {
      this.classList.remove('is-active');
      document.removeEventListener('click', handleClickOutside, true);
      if (overlay) overlay.removeEventListener('click', closePanel);
    };

    const handleClickOutside = (evt) => {
      if (!this.contains(evt.target) && evt.target !== overlay) {
        closePanel();
      }
    };

    buttonToggleVariants.addEventListener('click', (e) => {
      const isOpen = this.classList.contains('is-active');

      if (isOpen) {
        closePanel();
      } else {
        this.classList.add('is-active');
        document.addEventListener('click', handleClickOutside, true);
        if (overlay) overlay.addEventListener('click', closePanel);
      }
    });
  }

  syncInitialState() {
    this.ensureMainVariantInitialization();
    
    const mainSelectedOptions = this.mainVariantSelects.querySelectorAll('select option[selected], fieldset input:checked');
    
    mainSelectedOptions.forEach((mainOption) => {
      const optionValueId = mainOption.dataset.optionValueId;
      if (!optionValueId) return;
      
      const stickyOption = this.stickyVariantSelects.querySelector(`[data-option-value-id="${optionValueId}"]`);
      if (!stickyOption) return;
      
      if (stickyOption.tagName === 'INPUT' && stickyOption.type === 'radio') {
        if (!stickyOption.checked) {
          stickyOption.checked = true;
          stickyOption.classList.add('checked');
        }
      } else if (stickyOption.tagName === 'OPTION') {
        const select = stickyOption.closest('select');
        if (select && select.value !== stickyOption.value) {
          Array.from(select.options).forEach(opt => opt.removeAttribute('selected'));
          stickyOption.setAttribute('selected', 'selected');
          select.value = stickyOption.value;
        }
      }
    });
  }
  
  ensureMainVariantInitialization() {
    const mainSelectedOptions = this.mainVariantSelects.querySelectorAll('select option[selected], fieldset input:checked');
    
    if (mainSelectedOptions.length === 0) {
      const variantGroups = this.mainVariantSelects.querySelectorAll('fieldset, .product-form__input');
      
      variantGroups.forEach(group => {
        const firstAvailableInput = group.querySelector('input[type="radio"]:not(.disabled)');
        const firstAvailableOption = group.querySelector('option:not([disabled])');
        
        if (firstAvailableInput && !firstAvailableInput.checked) {
          firstAvailableInput.checked = true;
          firstAvailableInput.classList.add('checked');
          
          const selectedValueSpan = group.querySelector('[data-selected-value]');
          if (selectedValueSpan) {
            selectedValueSpan.innerHTML = firstAvailableInput.value;
          }
          
          firstAvailableInput.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (firstAvailableOption && !firstAvailableOption.selected) {
          const select = firstAvailableOption.closest('select');
          if (select) {
            Array.from(select.options).forEach(opt => opt.removeAttribute('selected'));
            firstAvailableOption.setAttribute('selected', 'selected');
            select.value = firstAvailableOption.value;
            
            const selectedValueSpan = group.querySelector('[data-selected-value]');
            if (selectedValueSpan) {
              selectedValueSpan.innerHTML = firstAvailableOption.value;
            }
            
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    } else {
      console.log('Main variant selects already have selected options:', mainSelectedOptions.length);
    }
  }
  
  syncMainToSticky(event) {
    this.isSyncing = true;
    
    try {
      this.stickyVariantSelects = this.querySelector('variant-selects') || this.stickyVariantSelects;

      const target = event.target;
      const optionValueId = this.getOptionValueId(target);
      if (!optionValueId || !this.stickyVariantSelects) return;
      
      const stickyOption = this.stickyVariantSelects.querySelector(`[data-option-value-id="${optionValueId}"]`);
      if (!stickyOption) return;
      
      if (stickyOption.tagName === 'INPUT' && stickyOption.type === 'radio') {
        if (!stickyOption.checked) {
          const wrapper = stickyOption.closest('.product-form__input') || this.stickyVariantSelects;
          wrapper
            .querySelectorAll('input[type="radio"]')
            .forEach((el) => {
              el.checked = false;
              el.classList.remove('checked');
              if (el.nextElementSibling && el.nextElementSibling.tagName === 'LABEL') {
                el.nextElementSibling.classList.remove('checked');
              }
            });
          stickyOption.checked = true;
          stickyOption.classList.add('checked');
          if (stickyOption.nextElementSibling && stickyOption.nextElementSibling.tagName === 'LABEL') {
            stickyOption.nextElementSibling.classList.add('checked');
          }
        }
      } else if (stickyOption.tagName === 'OPTION') {
        const select = stickyOption.closest('select');
        if (select && select.value !== stickyOption.value) {
          Array.from(select.options).forEach(opt => opt.removeAttribute('selected'));
          stickyOption.setAttribute('selected', 'selected');
          select.value = stickyOption.value;
        }
      }

      requestAnimationFrame(() => this.updateStickyAvailabilityFromMain());
    } finally {
      this.isSyncing = false;
    }
  }
  
  syncStickyToMain(event) {
    this.isSyncing = true;
    
    try {
      if (this.mainProductInfo) {
        this.mainVariantSelects = this.mainProductInfo.querySelector('variant-selects');
      }

      const target = this.getInputFromEventTarget(event.target) || event.target;
      const optionValueId = this.getOptionValueId(target);
      
      if (!this.mainVariantSelects) return;
      
      const mainOption = this.findMainOptionForStickyTarget(optionValueId, target);
      if (!mainOption) {
        console.warn('Sticky->Main: No main option found for', optionValueId, target?.name, target?.value);
        return;
      }
      
      if (mainOption.tagName === 'INPUT' && mainOption.type === 'radio') {
        const group = mainOption.name;
        Array.from(document.getElementsByName(group)).forEach((el) => {
          if (el instanceof HTMLInputElement && el.type === 'radio') {
            el.checked = false;
            el.classList.remove('checked');
          }
        });
        mainOption.checked = true;
        mainOption.classList.add('checked');
        requestAnimationFrame(() => {
          mainOption.dispatchEvent(new Event('input', { bubbles: true }));
          mainOption.dispatchEvent(new Event('change', { bubbles: true }));
          requestAnimationFrame(() => this.updateStickyAvailabilityFromMain());
        });
      } else if (mainOption.tagName === 'OPTION') {
        const select = mainOption.closest('select');
        if (select) {
          Array.from(select.options).forEach(opt => opt.removeAttribute('selected'));
          mainOption.setAttribute('selected', 'selected');
          select.value = mainOption.value;
          requestAnimationFrame(() => {
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
            requestAnimationFrame(() => this.updateStickyAvailabilityFromMain());
          });
        }
      }
    } finally {
      this.isSyncing = false;
    }
  }
  
  getOptionValueId(element) {
    const el = this.getInputFromEventTarget(element) || element;
    if (el && el.tagName === 'SELECT') {
      return el.selectedOptions[0]?.dataset.optionValueId;
    } else if (el && el.type === 'radio' && el.checked) {
      return el.dataset.optionValueId;
    }
    return null;
  }

  findMainOptionForStickyTarget(optionValueId, stickyInput) {
    if (optionValueId) {
      const byId = this.mainVariantSelects.querySelector(`[data-option-value-id="${optionValueId}"]`);
      if (byId) return byId;
    }

    if (stickyInput && stickyInput.name && stickyInput.value) {
      let candidates = Array.from(document.getElementsByName(stickyInput.name));
      if (!candidates.length) candidates = Array.from(document.getElementsByName(stickyInput.name.trim()));

      const radioMatch = candidates.find(
        (el) => el instanceof HTMLInputElement && el.type === 'radio' && el.value === stickyInput.value
      );
      if (radioMatch) return radioMatch;

      if (stickyInput.tagName === 'OPTION') {
        const selectName = stickyInput.closest('select')?.name;
        if (selectName) {
          let mainSelects = Array.from(document.getElementsByName(selectName));
          if (!mainSelects.length) mainSelects = Array.from(document.getElementsByName(selectName.trim()));
          const mainSelect = mainSelects.find((el) => el instanceof HTMLSelectElement);
          if (mainSelect) {
            const option = Array.from(mainSelect.options).find((opt) => opt.value === stickyInput.value);
            if (option) return option;
          }
        }
      }
    }

    return null;
  }

  getInputFromEventTarget(target) {
    if (target && target.tagName === 'LABEL') {
      const forId = target.getAttribute('for');
      if (forId) return document.getElementById(forId);
      if (target.previousElementSibling && target.previousElementSibling.tagName === 'INPUT') {
        return target.previousElementSibling;
      }
    }
    
    const wrapper = target.closest && target.closest('.product-form__input');
    if (wrapper) {
      const checkedRadio = wrapper.querySelector('input[type="radio"]:checked');
      if (checkedRadio) return checkedRadio;
      const selectEl = wrapper.querySelector('select');
      if (selectEl) return selectEl;
    }
    
    if (target && (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'OPTION')) return target;
    return null;
  }

  updateStickyAvailabilityFromMain() {
    if (!this.mainVariantSelects || !this.stickyVariantSelects) return;

    const mainOptions = this.mainVariantSelects.querySelectorAll(
      'input[type="radio"][data-option-value-id], select option[data-option-value-id]'
    );

    mainOptions.forEach((mainEl) => {
      const id = mainEl.dataset.optionValueId;
      if (!id) return;
      const stickyEl = this.stickyVariantSelects.querySelector(`[data-option-value-id="${id}"]`);
      if (!stickyEl) return;

      let mainUnavailable = false;
      if (mainEl.tagName === 'INPUT') {
        const input = mainEl;
        const label = input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL' ? input.nextElementSibling : null;
        mainUnavailable = !!(
          input.disabled ||
          input.getAttribute('aria-disabled') === 'true' ||
          input.classList.contains('disabled') ||
          input.classList.contains('visually-disabled') ||
          (label && (label.classList.contains('disabled') || label.classList.contains('visually-disabled') || label.classList.contains('unavailable') || label.classList.contains('sold-out')))
        );
      } else {
        mainUnavailable = mainEl.disabled || mainEl.getAttribute('aria-disabled') === 'true';
      }

      if (stickyEl.tagName === 'INPUT') {
        stickyEl.disabled = mainUnavailable;
        if (mainUnavailable) {
          stickyEl.setAttribute('aria-disabled', 'true');
          stickyEl.classList.add('disabled', 'visually-disabled');
          const label = stickyEl.nextElementSibling;
          if (label && label.tagName === 'LABEL') {
            label.classList.add('disabled', 'visually-disabled');
          }
        } else {
          stickyEl.removeAttribute('aria-disabled');
          stickyEl.classList.remove('disabled', 'visually-disabled');
          const label = stickyEl.nextElementSibling;
          if (label && label.tagName === 'LABEL') {
            label.classList.remove('disabled', 'visually-disabled');
          }
        }
      } else if (stickyEl.tagName === 'OPTION') {
        if (mainUnavailable) {
          stickyEl.setAttribute('disabled', '');
          stickyEl.setAttribute('aria-disabled', 'true');
        } else {
          stickyEl.removeAttribute('disabled');
          stickyEl.removeAttribute('aria-disabled');
        }
      }
    });
  }

  observeMainAvailabilityChanges() {
    if (!this.mainVariantSelects) return;
    const debouncedUpdate = (() => {
      let rafId = null;
      return () => {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => this.updateStickyAvailabilityFromMain());
      };
    })();

    const observer = new MutationObserver(debouncedUpdate);
    observer.observe(this.mainVariantSelects, {
      attributes: true,
      attributeFilter: ['disabled', 'class', 'aria-disabled'],
      subtree: true,
      childList: true
    });
    this._availabilityObserver = observer;
    }

    onScroll(entries) {
      entries.forEach((entry) => {
        if (entry.target === this.form) this.passedForm = entry.boundingClientRect.bottom < 0;
      });

      const shouldShow = this.passedForm && !this.reachedFooter;
      document.body.classList.toggle('sticky-cart-visible', shouldShow);
      this.classList.toggle('is-visible', shouldShow);
    
      if (shouldShow) {
        document.body.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
      } else {
        document.body.style.setProperty('--sticky-atc-height', `0px`);
      }

      if (!shouldShow) this.classList.remove('sticky-open');
    }
  }

  if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyATC);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-paired-products"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('cart-paired-products')) return;

    var CACHE_PREFIX = 'cpp:v2:';
    var CACHE_TTL = 30 * 60 * 1000;
    var memoryCache = new Map();

    function readCache(key) {
      if (memoryCache.has(key)) return memoryCache.get(key);
      try {
        var raw = window.sessionStorage.getItem(CACHE_PREFIX + key);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || Date.now() - data.t > CACHE_TTL) return null;
        memoryCache.set(key, data.h);
        return data.h;
      } catch (e) {
        return null;
      }
    }

    function writeCache(key, html) {
      memoryCache.set(key, html);
      try {
        window.sessionStorage.setItem(CACHE_PREFIX + key, JSON.stringify({ t: Date.now(), h: html }));
      } catch (e) {}
    }

    function rootUrl() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function parseCards(html) {
      var wrap = document.createElement('div');
      wrap.innerHTML = html || '';
      return Array.prototype.slice.call(wrap.querySelectorAll('.cpp-card'));
    }

    class CartPairedProducts extends HTMLElement {
      connectedCallback() {
        if (!this._ready) {
          this._ready = true;
          this.track = this.querySelector('[data-cpp-track]');
          this.prevBtn = this.querySelector('[data-cpp-prev]');
          this.nextBtn = this.querySelector('[data-cpp-next]');
          this.limit = parseInt(this.dataset.limit, 10) || 8;
          this.exclude = new Set((this.dataset.exclude || '').split(',').filter(Boolean));

          var self = this;
          if (this.prevBtn) this.prevBtn.addEventListener('click', function (e) { e.preventDefault(); self.scrollByCard(-1); });
          if (this.nextBtn) this.nextBtn.addEventListener('click', function (e) { e.preventDefault(); self.scrollByCard(1); });
          if (this.track) this.track.addEventListener('scroll', function () { self.updateArrows(); }, { passive: true });

          this.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-cpp-add]');
            if (btn && self.contains(btn)) {
              e.preventDefault();
              e.stopPropagation();
              self.addToCart(btn);
            }
          });

          // Keep the theme's cart form from reacting to the size dropdown.
          this.addEventListener('change', function (e) {
            if (e.target.matches('.cpp-card__variant')) {
              e.stopPropagation();
              self.onVariantChange(e.target);
            }
          });
          this.addEventListener('input', function (e) {
            if (e.target.matches('.cpp-card__variant')) e.stopPropagation();
          });

          this.load();
        }

        if (window.ResizeObserver && this.track) {
          var me = this;
          this.resizeObserver = new ResizeObserver(function () { me.updateArrows(); });
          this.resizeObserver.observe(this.track);
        }
        this.updateArrows();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      load() {
        var self = this;
        var sources = (this.dataset.sources || '').split(',').filter(Boolean).slice(0, 3);
        var url = this.dataset.recsUrl;
        var intent = this.dataset.intent || 'complementary';

        if (!sources.length || !url) {
          this.render([]);
          return;
        }

        var cached = sources.map(function (id) { return readCache(id + ':' + intent); });
        if (cached.every(function (h) { return h !== null; })) {
          this.render(cached);
          return;
        }

        this.classList.add('is-loading');
        Promise.all(
          sources.map(function (id, i) {
            return cached[i] !== null ? cached[i] : self.fetchRecommendations(id, intent, url);
          })
        ).then(function (lists) {
          self.render(lists);
        });
      }

      fetchRecommendations(productId, intent, url) {
        var key = productId + ':' + intent;
        var get = function (type) {
          var endpoint =
            url + '?product_id=' + encodeURIComponent(productId) + '&limit=10&intent=' + type + '&section_id=cart-paired-recommendations';
          return fetch(endpoint)
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (text) {
              if (!text) return '';
              var doc = new DOMParser().parseFromString(text, 'text/html');
              var wrap = doc.querySelector('.cpp-recs');
              return wrap && wrap.querySelector('.cpp-card') ? wrap.innerHTML.trim() : '';
            })
            .catch(function () { return ''; });
        };

        var first = intent === 'related' ? get('related') : get('complementary');
        return first.then(function (html) {
          if (!html && intent === 'complementary') return get('related');
          return html;
        }).then(function (html) {
          writeCache(key, html || '');
          return html || '';
        });
      }

      render(htmlLists) {
        if (!this.track) return;
        var self = this;
        var lists = htmlLists.map(parseCards);
        var seen = new Set();
        var out = [];

        var push = function (card) {
          var pid = card.dataset.productId;
          if (!pid || seen.has(pid) || self.exclude.has(pid)) return;
          seen.add(pid);
          out.push(card);
        };

        // Interleave recommendations from each cart product, then fill with the fallback collection.
        var longest = lists.reduce(function (m, l) { return Math.max(m, l.length); }, 0);
        for (var i = 0; i < longest; i++) {
          lists.forEach(function (l) { if (l[i]) push(l[i]); });
        }
        Array.prototype.slice.call(this.track.querySelectorAll('.cpp-card')).forEach(push);

        // Put the cheapest piece that closes the gap to the next free gift first
        var gap = this.giftGap();
        if (gap > 0) {
          var best = null;
          out.forEach(function (c) {
            var p = parseInt(c.dataset.price, 10) || 0;
            if (p >= gap && (!best || p < (parseInt(best.dataset.price, 10) || 0))) best = c;
          });
          if (best) {
            out.splice(out.indexOf(best), 1);
            out.unshift(best);
            var badge = best.querySelector('.cpp-card__badge');
            if (badge) { badge.textContent = this.dataset.gapLabel || 'Unlocks your free gift'; badge.hidden = false; }
          }
        }

        var finalCards = out.slice(0, this.limit);
        var label = this.dataset.buttonLabel;
        if (label) {
          finalCards.forEach(function (c) {
            var l = c.querySelector('.cpp-card__add-label');
            if (l) l.textContent = label;
          });
        }

        this.track.replaceChildren.apply(this.track, finalCards);
        this.track.scrollLeft = 0;
        this.classList.remove('is-loading');
        this.updateArrows();
      }

      giftGap() {
        if (this.dataset.gapAware !== 'true') return 0;
        var subtotal = parseInt(this.dataset.subtotal, 10) || 0;
        var scope = this.closest('cart-drawer, cart-items-component') || document;
        var cfgEl = scope.querySelector('[data-fgb-config]') || document.querySelector('[data-fgb-config]');
        if (!cfgEl) return 0;
        var cfg;
        try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return 0; }
        var tiers = (cfg && (cfg.tiers || cfg.tierList)) || [];
        var gap = 0;
        tiers.forEach(function (tier) {
          var th = parseInt(tier && tier.threshold, 10) || 0;
          if (th > subtotal && (!gap || th - subtotal < gap)) gap = th - subtotal;
        });
        return gap;
      }

      updateArrows() {
        var t = this.track;
        if (!t) return;
        var max = t.scrollWidth - t.clientWidth - 2;
        if (this.prevBtn) this.prevBtn.disabled = t.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = t.scrollLeft >= max;
        this.classList.toggle('has-overflow', max > 2);
      }

      scrollByCard(direction) {
        var card = this.track && this.track.querySelector('.cpp-card');
        if (!card) return;
        var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }

      onVariantChange(select) {
        var opt = select.options[select.selectedIndex];
        var card = select.closest('.cpp-card');
        if (!opt || !card) return;
        var amount = card.querySelector('.cpp-card__amount');
        if (amount && opt.dataset.price) amount.textContent = opt.dataset.price;
        var compare = card.querySelector('.cpp-card__compare');
        if (opt.dataset.compare) {
          if (!compare && amount) {
            compare = document.createElement('s');
            compare.className = 'cpp-card__compare';
            amount.parentNode.insertBefore(compare, amount);
          }
          if (compare) compare.textContent = opt.dataset.compare;
        } else if (compare) {
          compare.remove();
        }
      }

      showError(card, message) {
        var el = card && card.querySelector('.cpp-card__error');
        if (!el) return;
        el.textContent = message;
        el.hidden = false;
      }

      addToCart(btn) {
        if (btn.getAttribute('aria-busy') === 'true') return;
        var self = this;
        var card = btn.closest('.cpp-card');
        var input = card && card.querySelector('.cpp-card__variant');
        var variantId = input && input.value;
        if (!variantId) return;

        var errorEl = card.querySelector('.cpp-card__error');
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
        btn.setAttribute('aria-busy', 'true');
        btn.classList.add('is-loading');
        btn.disabled = true;

        var sectionIds = new Set();
        document.querySelectorAll('cart-items-component[data-section-id], cart-drawer-items[data-section-id]').forEach(function (el) {
          sectionIds.add(el.dataset.sectionId);
        });
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) sectionIds.add('cart-icon-bubble');

        var body = { items: [{ id: Number(variantId), quantity: 1 }] };
        if (sectionIds.size) {
          body.sections = Array.from(sectionIds).join(',');
          body.sections_url = window.location.pathname;
        }

        var success = false;
        fetch(rootUrl() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        })
          .then(function (r) {
            return r.json().then(function (json) { return { ok: r.ok, json: json }; });
          })
          .then(function (res) {
            var json = res.json || {};
            if (!res.ok || json.status) {
              self.showError(card, json.description || json.message || 'Could not add this item. Please try again.');
              return;
            }
            success = true;
            var sections = json.sections || {};

            if (bubble && sections['cart-icon-bubble']) {
              var bdoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
              var bsrc = bdoc.querySelector('.shopify-section');
              if (bsrc) bubble.innerHTML = bsrc.innerHTML;
            }

            var cartSections = {};
            Object.keys(sections).forEach(function (id) {
              if (id !== 'cart-icon-bubble' && sections[id]) cartSections[id] = sections[id];
            });

            var cartComponent = document.querySelector('cart-drawer-items') || document.querySelector('cart-items-component');
            var updated = false;
            if (cartComponent && typeof cartComponent.updateSections === 'function' && Object.keys(cartSections).length) {
              try { cartComponent.updateSections(cartSections); updated = true; } catch (e) {}
            }

            return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
                cart.sections = sections;
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
                if (!updated && window.location.pathname.indexOf('/cart') !== -1) window.location.reload();
              });
          })
          .catch(function () {
            self.showError(card, 'Could not add this item. Please try again.');
          })
          .finally(function () {
            if (!btn.isConnected) return;
            btn.removeAttribute('aria-busy');
            btn.classList.remove('is-loading');
            btn.disabled = false;
            if (success) {
              var l = btn.querySelector('.cpp-card__add-label');
              if (l) l.textContent = self.dataset.addedLabel || 'Added';
            }
          });
      }
    }

    customElements.define('cart-paired-products', CartPairedProducts);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-sticky-checkout"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('cart-sticky-checkout')) return;

    /* Shows the bar whenever the page's own Checkout button is not on screen.
       Uses plain scroll/resize checks (works inside the theme editor and after
       the cart re-renders) and sits just above the mobile sticky toolbar. */
    class CartStickyCheckout extends HTMLElement {
      connectedCallback() {
        var self = this;
        /* The cart section creates its own stacking layer (z-index: 0), which let
           page content below the cart paint over this bar. Live on <body> instead. */
        if (this.parentElement !== document.body) {
          document.querySelectorAll('body > cart-sticky-checkout').forEach(function (el) { if (el !== self) el.remove(); });
          document.body.appendChild(this);
          return;
        }
        this.button = this.querySelector('.cso__button');
        this.tick = function () {
          if (self._raf) return;
          self._raf = requestAnimationFrame(function () { self._raf = null; self.update(); });
        };
        if (this.button) {
          this.button.addEventListener('click', function (e) {
            if (!document.getElementById('cart')) {
              e.preventDefault();
              var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
              window.location.href = root + 'checkout';
            }
          });
        }
        window.addEventListener('scroll', this.tick, { passive: true });
        window.addEventListener('resize', this.tick);
        document.addEventListener('cart:updated', this.tick);
        this.timer = setInterval(this.tick, 700);
        this.update();
      }
      disconnectedCallback() {
        if (!this.tick) return;
        window.removeEventListener('scroll', this.tick);
        window.removeEventListener('resize', this.tick);
        document.removeEventListener('cart:updated', this.tick);
        clearInterval(this.timer);
        document.body.classList.remove('has-cso');
      }
      toolbarCover() {
        var vh = window.innerHeight, cover = 0, z = 0;
        document.querySelectorAll('toolbar-mobile, .toolbar-mobile').forEach(function (el) {
          var cs = getComputedStyle(el);
          if (cs.display === 'none' || cs.visibility === 'hidden' || +cs.opacity === 0) return;
          var r = el.getBoundingClientRect();
          if (r.height > 0 && r.top < vh && r.bottom > vh - 2) cover = Math.max(cover, vh - r.top);
          var zi = parseInt(cs.zIndex, 10);
          if (!isNaN(zi)) z = Math.max(z, zi);
          var p = el.parentElement;
          while (p && p !== document.body) { var pz = parseInt(getComputedStyle(p).zIndex, 10); if (!isNaN(pz)) z = Math.max(z, pz); p = p.parentElement; }
        });
        return { cover: Math.max(0, Math.round(cover)), z: z };
      }
      nativeVisible(bottomCover) {
        var vh = window.innerHeight, header = 0;
        var natives = document.querySelectorAll('.cart__checkout-button[name="checkout"], #cart button[name="checkout"]');
        if (!natives.length) return null;
        for (var i = 0; i < natives.length; i++) {
          var b = natives[i];
          if (this.contains(b) || b.closest('cart-drawer')) continue;
          var r = b.getBoundingClientRect();
          if (!r.height) continue;
          if (r.top >= 70 && r.bottom <= vh - bottomCover) return true;
        }
        return false;
      }
      update() {
        if (!this.isConnected) return;
        var tb = this.toolbarCover();
        this.style.bottom = tb.cover + 'px';
        this.style.zIndex = String(Math.max(tb.z + 1, 5));
        document.documentElement.style.setProperty('--cso-height', this.offsetHeight + 'px');
        var nv = this.nativeVisible(tb.cover + this.offsetHeight);
        var visible = nv === false;
        if (visible !== this._visible) {
          this._visible = visible;
          this.classList.toggle('is-visible', visible);
          document.body.classList.toggle('has-cso', visible);
        }
      }
    }
    customElements.define('cart-sticky-checkout', CartStickyCheckout);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    class EmailSignup extends HTMLElement {
    constructor() {
      super();
      this._handleOutsideClick = this._handleOutsideClick.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('[id^="EmailSignup-"]');
      this.checkbox = this.form?.querySelector('[id^="agree_condition-"]');
      this.submitButton = this.form?.querySelector("button[id^='EmailSignup-submit-']");
      this.subscriptionForm = this.querySelector('.subscription-form');
      this.emailForm = this.querySelector('.email-signup__form');
      this.promoBtn = this.querySelector('.promo-btn');
      // this.backBtn = this.emailForm.querySelector('.back-btn');

      this.initAgreeCondition();
      this.initPromoToggle();

      if (window.location.search.includes('contact_posted=true')) {
        this.showEmailForm(true);
      }
    }

    initAgreeCondition() {
      if (!this.checkbox || !this.submitButton) return;

      this.submitButton.disabled = true;

      this.checkbox.addEventListener('change', () => {
        this.submitButton.disabled = !this.checkbox.checked;
      });

      this.form.addEventListener('submit', (e) => {
        if (!this.checkbox.checked) {
          e.preventDefault();
          alert('Please agree to the terms and conditions before submitting.');
        }
      });
    }

    initPromoToggle() {
      if (!this.subscriptionForm || !this.emailForm || !this.promoBtn) return;

      this.emailForm.style.display = 'none';

      this.promoBtn.addEventListener('click', () => this.showEmailForm());
      // this.backBtn?.addEventListener('click', () => this.showSubscriptionForm());
    }

    async showEmailForm(skipHideAnim = false) {
      if (!skipHideAnim) await this._animateHide(this.subscriptionForm);
      this.subscriptionForm.style.display = 'none';
      this.emailForm.style.display = '';
      await this._animateShow(this.emailForm);

      document.addEventListener('click', this._handleOutsideClick);
    }

    async showSubscriptionForm() {
      await this._animateHide(this.emailForm);
      this.emailForm.style.display = 'none';
      this.subscriptionForm.style.display = '';
      await this._animateShow(this.subscriptionForm);

      document.removeEventListener('click', this._handleOutsideClick);
    }

    _handleOutsideClick(e) {
      if (!this.contains(e.target)) {
        this.showSubscriptionForm();
      }
    }

    async _animateShow(element) {
      element.style.overflow = 'hidden';
      await Motion.timeline([
        [
          element,
          { height: ['0px', `${element.scrollHeight}px`] },
          { duration: 0.45, easing: 'cubic-bezier(0.7, 0, 0.3, 1)' },
        ],
        [
          element,
          { opacity: [0, 1], transform: ['translateX(-1rem)', 'translateX(0)'] },
          { duration: 0.25, at: '-0.1' },
        ],
      ]).finished;
      element.style.height = 'auto';
      element.style.overflow = 'visible';
    }

    async _animateHide(element) {
      element.style.overflow = 'hidden';
      await Motion.timeline([
        [element, { opacity: 0, transform: ['translateX(0)', 'translateX(1rem)'] }, { duration: 0.15 }],
        [
          element,
          { height: [`${element.clientHeight}px`, '0px'] },
          { duration: 0.35, at: '<', easing: 'cubic-bezier(0.7, 0, 0.3, 1)' },
        ],
      ]).finished;
      element.style.height = 'auto';
      element.style.overflow = 'visible';
    }
  }
  if (!customElements.get('email-signup')) customElements.define('email-signup', EmailSignup);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["promotion-coupon-code"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll(".coupon-code-block .coupon-code-icon").forEach(function (btn) {
        btn.addEventListener("click", function () {
        const parent = btn.closest(".coupon-code-block");
        const text = parent.getAttribute("data-text");

        parent.classList.add("copied");
        setTimeout(() => {
            parent.classList.remove("copied");
        }, 1500);
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["store-locator"] && !Shopify.designMode) return;
  try {
    (function() {
    var root = document.querySelector('.storeLocator');
    if (!root) return;

    var items = root.querySelectorAll('.storeLocator__item');
    var mapEl = root.querySelector('#map');
    if (!mapEl || !items.length) return;

    function setActive(item) {
      items.forEach(function(i) { i.classList.remove('active'); });
      item.classList.add('active');
    }

    function renderMapFrom(item) {
      var html = item.getAttribute('data-map') || '';
      mapEl.classList.add('is-loading');
      mapEl.innerHTML = html;

      setTimeout(function() {
        mapEl.classList.remove('is-loading');
      }, 500);
    }

    items.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        setActive(item);
        renderMapFrom(item);
      });
    });

    // Initialize with first item
    var first = items[0];
    if (first) {
      setActive(first);
      renderMapFrom(first);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
